import { useEffect } from "react"


export const useOutsideClickHandler = ({ objRef, isDropdown, setDropdown }) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                objRef?.current instanceof Node &&
                !objRef.current.contains(event.target)
            ) {
                setDropdown(false)
            }
        }
        if (isDropdown) {
            document.addEventListener("mousedown", handleClickOutside)
        }

        // Cleanup
        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [isDropdown, objRef, setDropdown])
}